import service from '../../utils/request'


const getOrderCenter = (data) => {
    return service({
        url: 'api/order/getOrders',
        method: 'post',
        data
    })
}
const getCourseCatalog = (data) => {
    return service({
        url: 'api/personal/courseCatalog',
        method: 'post',
        data
    })
}

export {
    getOrderCenter,
    getCourseCatalog
}